import Vue from 'vue'

import FormatHelper from 'Helpers/FormatHelper'

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter(
  'formatCurrency',
  function (
    value,
    maximumFractionDigits = 2,
    minimumFractionDigits = 0,
    currency = 'USD'
  ) {
    return FormatHelper.formatCurrency(
      value,
      maximumFractionDigits,
      minimumFractionDigits,
      currency
    )
  }
)

Vue.filter('formatDate', function (value, format) {
  return FormatHelper.formatDate(value, format)
})

Vue.filter(
  'formatNumber',
  function (value, maximumFractionDigits = 2, minimumFractionDigits = 0) {
    return FormatHelper.formatNumber(
      value,
      maximumFractionDigits,
      minimumFractionDigits
    )
  }
)

Vue.directive('digits', {
  inserted(el, binding) {
    el.oninput = (event) => {
      const formattedValue = parseInt(event.target.value, 10)
      el.value = isNaN(formattedValue) ? '' : formattedValue

      if (
        Vue._.get(binding, 'value.onlyPositiveNumbers') === true &&
        el.value < 0
      ) {
        el.value *= -1
      }
    }
  },
})
